import commonStrings from "rivals/shared/strings/common";
import registrationStrings from "rivals/shared/strings/registration";
import subscriptionStrings from "rivals/shared/strings/subscription";

export default {
  ...commonStrings,
  ...registrationStrings,
  ...subscriptionStrings,
  joinForFree: "Join for free with limited access. ",
  subtitle: "Stay informed with exclusive Rivals access.",
  toSite: (siteName: string): string => `to ${siteName.replace(".com", "")}?`,
  whySubscribe: "Why Subscribe"
};
